import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

import ReactGA from "react-ga4";
import { BrowserRouter, useLocation } from "react-router";
import { useEffect } from "react";
import PersonalProject from "./components/PersonalProject";
import QuotesILiveBy from "./components/Quotes";

const TRACKING_ID = "YOUR_TRACKING_ID";
ReactGA.initialize(TRACKING_ID);

function usePageTracking() {
  let location = useLocation();
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);
}

function App() {
  usePageTracking();

  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Skills />
      <PersonalProject />
      <Projects />
      {/* <Contact /> */}
      <QuotesILiveBy />
      <Footer />
    </div>
  );
}

export default function AppWithRouter() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
